module.exports = {
	"IMOMO_CENTRAL_ASIA": "iEasyHydro",
	"USERNAME_OR_PASSWORD_WRONG": "The username or password is wrong.",
	"USER_NOT_APPROVED_ORGANIZATION": "The user has not been approved by the organization.",
	"H_Q_TABLE": "H/Q Table",
	"MINIMUM_H_CM": "Minimum H (cm)",
	"MAXIMUM_H_CM": "Maximum H (cm)",
	"MINIMUM_Q_M3_S": "Minimum Q (m<sup>3</sup>/s)",
	"MAXIMUM_Q_M3_S": "Maximum Q (m<sup>3</sup>/s)",
	"APPLY": "Apply",
	"DISCHARGE_DATA": "Discharge data",
	"DELETE_SELECTED_ARTIFICIAL_DATA": "Delete selected artificial data",
	"DATE": "Date",
	"WATER_LEVEL": "Water level",
	"DISCHARGE": "Discharge",
	"CM": "cm",
	"M3_S": "m<sup>3</sup>/s",
	"ADD_DISCHARGE_DATA_POINT": "Add discharge data point",
	"H_CM": "H (cm)",
	"Q_M3_S": "Q (m<sup>3</sup>/s)",
	"H_CM_OLD": "H (cm) - old",
	"Q_M3_S_OLD": "Q (m<sup>3</sup>/s) - old",
	"CANCEL": "Cancel",
	"ADD": "Add",
	"DISCHARGE_MODELS": "Discharge models",
	"SHOW_HIDDEN_MODELS": "Show hidden models",
	"DELETE_DISCHARGE_MODEL": "Delete discharge model",
	"DELETE_DISCHARGE_MODEL_EXTENDED": "Deleting a discharge model will recalculate any associated discharge values using the previous model. This action is permanent.",
	"DELETE": "Delete",
	"NON_EXISTENT_STATION_CODE": "Non-existent station code",
	"NON_EXISTENT_STATION_CODE_EXTENDED": "There is no station with code {stationCode} in the system.",
	"FORBIDDEN_STATION_CODE": "Forbidden station code",
	"FORBIDDEN_STATION_CODE_EXTENDED": "The station with code {stationCode} belongs to a different organization.",
	"UNEXPECTED_ERROR": "Unexpected error",
	"UNEXPECTED_ERROR_EXTENDED": "An unexpected error has occurred. Please try again and if the error persists please contact the support person.",
	"OK": "Ok",
	"TRY_AGAIN": "Try again",
	"ACCOUNT": "Account",
	"ORGANIZATION": "Organization",
	"LOG_IN": "Log in",
	"LOG_OUT": "Log out",
	"MENU": "Menu",
	"HOME": "Home",
	"TOOLS": "Tools",
	"OPERATIONAL_HYDROLOGY": "Operational Hydrology",
	"DISCHARGE_FORECASTING": "Discharge Forecasting",
	"STATION_MANAGEMENT": "Station Management",
	"HELP": "Help",
	"FEEDBACK": "Feedback",
	"SETTINGS": "Settings",
	"ABOUT_US": "About us",
	"USERS": "Users",
	"IMOMO_HYDROMETEOROLOGY": "iMoMo Hydrometeorology",
	"WELCOME_BACK": "Welcome back!",
	"CLOUD_AUTOMATED_WORKSTATION_OF_THE_OPERATIONAL_HYDROLOGIST": "Cloud automated workstation of the operational hydrologist",
	"1_PROCESSING_OF_KH_15_TELEGRAMS_WITH_DAILY_HYDROLOGICAL_DATA": "1. Processing of KH-15 telegrams with daily hydrological data.",
	"2_CREATION_AND_MODIFICATION_OF_OPERATIONAL_DISCHARGE_RATION_CURVES": "2. Creation and modification of operational discharge ration curves.",
	"3_CALCULATION_OF_CURRENT_AND_DAILY_AVERAGE_HYDROLOGICAL_VALUES": "3. Calculation of current and daily average hydrological values and storage it in the daily operational journal.",
	"4_RELEASE_OF_THE_DAILY_HYDROLOGICAL_BULLETIN": "4. Release of the daily hydrological bulletin.",
	"5_HYDROLOGICAL_FORECASTING": "5. Hydrological forecasting (daily, pentad, decadal, monthly and seasonal)",
	"NAME": "Name",
	"ADDRESS": "Address",
	"ADMIN_USER": "Admin user",
	"USER_DETAILS": "User details",
	"USERNAME": "Username",
	"PASSWORD": "Password",
	"REPEAT_PASSWORD": "Repeat password",
	"NEW_PASSWORD": "New password",
	"REPEAT_NEW_PASSWORD": "Repeat new password",
	"EMAIL": "Email",
	"EDIT_USER": "Edit user",
	"ADD_USER": "Add user",
	"SAVE": "Save",
	"DELETING": "Deleting",
	"SAVING": "Saving",
	"BACK": "Back",
	"ROLE": "Role",
	"DELETE_USER": "Delete user?",
	"DELETE_ORGANIZATION": "Delete organization?",
	"DELETE_FORECAST_MODEL": "Delete forecast model?",
	"DELETE_CONFIRMATION": "Are you sure you want to delete \"{item}\"?",
	"THIS_FIELD_IS_REQUIRED": "This field is required",
	"THE_VALUE_IS_TOO_LONG": "The value is too long.",
	"THE_VALUE_IS_TOO_SHORT": "The value is too short.",
	"LOGIN": "Login",
	"CREATE_NEW_USER": "Create new user",
	"LOG_IN_AS_GUEST": "Log in as guest",
	"FORGOT_YOUR_PASSWORD": "Forgot your password?",
	"ANNOUNCEMENTS": "Announcements",
	"OPERATIONAL_DATA_INPUT": "Operational Data Input",
	"ENTER_TELEGRAM": "Enter telegram",
	"OPERATIONAL_JOURNAL": "Operational Journal",
	"VIEW_JOURNAL": "View journal",
	"DAILY_OPERATIONAL_BULLETIN": "Daily Operational Bulletin",
	"GENERATE_BULLETIN": "Generate bulletin",
	"TELEGRAM": "Telegram",
	"DISCHARGE_CURVE": "Discharge curve",
	"SAVE_DATA": "Save data",
	"NEXT": "Next",
	"PREVIOUS": "Previous",
	"SUBMIT_DATA": "Submit data",
	"KN15_TELEGRAM": "KN-15 Telegram",
	"STATION": "Station",
	"PROCESS_TELEGRAM": "Process telegram",
	"TELEGRAM_IS_REQUIRED": "Telegram is required.",
	"M2": "m<sup>2</sup>",
	"REPORTED_WATER_LEVEL": "Reported water level",
	"PREVIOUS_DAY": "Previous day",
	"TELEGRAM_DAY": "Telegram day",
	"8_AM": "8:00 AM",
	"8_PM": "8:00 PM",
	"DAILY_AVERAGE": "Daily average",
	"DAILY_CHANGE": "Daily change",
	"WATER_LEVEL_TREND_IS_CORRECT": "Water level trend is correct.",
	"WATER_LEVEL_TREND_WRONG": "Water level trend could not be verified or is wrong.",
	"REPORTED_DISCHARGE": "Reported discharge",
	"CROSS_SECTION_AREA": "Cross-section area",
	"MAXIMUM_DEPTH": "Maximum depth",
	"ICE_PHENOMENA": "Ice phenomena",
	"CODE": "Code",
	"DESCRIPTION": "Description",
	"INTENSITY": "Intensity",
	"DISCHARGE_CALCULATION_DISABLED": "Discharge calculation disabled",
	"ADJUST_DISCHARGE_MODEL": "Adjust discharge model",
	"IDENTIFIER": "Identifier",
	"ADD_DELTA_H": "Add \\u0394H",
	"FIT_TO_SELECTED_DATA": "Fit to selected data",
	"REFERENCE_MODEL": "Reference model",
	"DELTA_H": "\\u0394H",
	"DATA_SELECTED": "{count, plural, =0{No data points selected.} one{Select one more data point.} other{{count} data points selected.} }",
	"NO_NEW_MODEL": "No new model",
	"VALID_FROM": "Valid from",
	"CREATE_MODEL": "Create model",
	"DELETE_MODEL": "Delete model",
	"DISCHARGE_MODEL": "Discharge model",
	"PROCESSED_DATA": "Processed data",
	"AVERAGE": "Average",
	"MONTH": "Month",
	"YEAR": "Year",
	"LOAD_JOURNAL": "Load journal",
	"DAILY_DATA": "Daily data",
	"TREND": "Trend",
	"WATER_CELSIUS": "Water (℃)",
	"AIR_CELSIUS": "Air (℃)",
	"ICE": "Ice",
	"MINIMUM": "Minimum",
	"MAXIMUM": "Maximum",
	"EDIT_SELECTED_ROW": "Edit selected row",
	"EDIT_DAILY_DATA_ROW": "Edit daily data row",
	"APPLY_CHANGES": "Apply changes",
	"H_8_AM": "H (8:00am)",
	"H_8_PM": "H (8:00pm)",
	"H_AVERAGE": "H (Average):",
	"DAILY_DATA_WAS_EDITED": "Daily data was edited.",
	"ERROR_UPDATING_DATA": "An error occurred while updating the data. Please try again.",
	"DELETE_SELECTED_ROW_FROM_DATABASE": "Delete selected row from database",
	"F_M2": "F (m2)",
	"EDIT_METEO_ROW": "Edit meteo row",
	"EDIT_DISCHARGE_ROW": "Edit discharge row",
	"METEO_DATA_WAS_EDITED": "Meteo data was edited.",
	"DISCHARGE_DATA_WAS_EDITED": "Discharge data was edited.",
	"ERROR_UPDATING_DISCHARGE_DATA": "An error occurred while updating the discharge data. Please try again.",
	"DELETE_DISCHARGE_DATA": "Delete discharge data",
	"DELETE_DATA_WARNING": "Are you sure you want to delete this data. This action is permanent.",
	"DISCHARGE_DATA_WAS_DELETED": "Discharge data was deleted.",
	"ERROR_DELETING_DISCHARGE_DATA": "An error occurred with deleting the discharge data. Please try again.",
	"DECADAL_DATA": "Decadal data",
	"DECADE": "Decade",
	"MONTHLY_AVERAGE": "Monthly average",
	"OPERATIONAL_BULLETIN": "Operational Bulletin",
	"BULLETIN_DATE": "Bulletin date",
	"PREPARE_BULLETIN": "Prepare bulletin",
	"DOWNLOAD_BULLETIN": "Download bulletin",
	"HYDROLOGICAL_DISCHARGE_STATIONS": "Hydrological Discharge Stations",
	"STATION_CODE": "Station Code",
	"STATION_NAME": "Station Name",
	"REGION": "Region",
	"RIVER_BASIN": "River Basin",
	"ADD_STATION": "Add station",
	"EDIT_STATION": "Edit station",
	"SHOW_DISCHARGE_CURVES": "Show discharge curves",
	"SHOW_DISCHARGE_TIME_SERIES": "Show discharge time series",
	"SHOW_HISTORIC_DATA": "Show historic data",
	"STEP_1_DETAILS": "Step 1: Details",
	"STATION_DETAILS": "Station details",
	"LOCAL_CODE": "Local Code",
	"BASIN": "Basin",
	"COUNTRY": "Country",
	"LOCATION": "Location",
	"MAXIMUM_DISCHARGE_LEVEL_M3_S": "Dangerous discharge (m3/s)",
	"VALUE_IS_REQUIRED": "Value is required.",
	"INVALID_VALUE": "Invalid value.",
	"VERIFYING": "Verifying...",
	"CODE_IS_ALREADY_USED": "Code is already used.",
	"VALUE_IS_TOO_LONG": "Value is too long.",
	"STEP_2_AGGREGATIONS": "Step 2: Aggregations",
	"STEP_2_DISCHARGE_CURVE": "Step 2: Discharge Curve",
	"DISCHARGE_POINTS": "Discharge points",
	"WATER_LEVEL_CM": "Water level (cm)",
	"DISCHARGE_M3_S": "Discharge (m3/s)",
	"EG_INITIAL_STATION_MODEL": "E.g. Initial station model",
	"SHOW_H_Q_TABLE": "Show H/Q table",
	"AN_IDENTIFIER_IS_REQUIRED": "An identifier is required.",
	"IDENTIFIER_IS_TOO_LONG": "Identifier is too long.",
	"MODEL_H_Q_TABLE": "Model's H-Q table",
	"STEP_3_HISTORICAL_DISCHARGE_DATA": "Step 3: Historical Discharge Data",
	"HISTORICAL_DISCHARGE_DATA_UPLOAD": "Historical data upload",
	"PLEASE_UPLOAD_HISTORICAL_METEO": "Please upload the historical 10-day meteo data for the station.",
	"PLEASE_UPLOAD_HISTORICAL": "Please upload the historical 10-day discharge data for the station.",
	"DATA_AVAILABLE_FOR_DOWNLOAD": "The data will be always available for download and can be updated at any time.",
	"DATA_MUST_BE_EXCEL": "The data must be uploaded as an Excel (.xls/.xlsx) file with the same format as the example file.",
	"NO_FILE_SELECTED": "No file selected",
	"DOWNLOAD_EXAMPLE_FILE": "Download example file",
	"SELECT_FILE": "Select file",
	"CHANGE": "Change",
	"VALIDATE": "Validate",
	"VALIDATED": "Validated",
	"STEP_4_REVIEW_AND_CREATE": "Step 4: Review and Create",
	"CREATE_STATION": "Create station",
	"STATUS": "Status",
	"HISTORICAL_DISCHARGE_DATA": "Historical discharge data",
	"DONE": "Done",
	"PENDING": "Pending",
	"CREATE": "Create",
	"STATION_LIST": "Station list",
	"SELECT_A_STATION": "Select a station",
	"DISCHARGE_NORM": "Discharge norm",
	"I": "I",
	"II": "II",
	"III": "III",
	"NEW_DATA_MUST_BE_EXCEL": "New data must be uploaded as an Excel (.xls/.xlsx) file with the same format as the example file.",
	"DOWNLOAD_DATA": "Download data",
	"UPLOAD_NEW_DATA": "Upload new data",
	"HYDROLOGICAL_YEAR": "Hydrological year",
	"CHANGE_YEAR": "Change year",
	"NEW_DISCHARGE_MODEL": "New discharge model",
	"MODEL_IDENTIFIER": "Model identifier",
	"NEW_MODEL": "New model",
	"SAVE_NEW_MODEL": "Save new model",
	"MEASURED_PRECIPITATION_TIME_SERIES": "Measured precipitation time series",
	"MEASURED_TEMPERATURE_TIME_SERIES": "Measured temperature time series",
	"MEASURED_DISCHARGE_TIME_SERIES": "Measured discharge time series",
	"LOAD_GRAPH": "Load graph",
	"INITIAL_YEAR": "Initial year",
	"FINAL_YEAR": "Final year",
	"HISTORICAL_NORM": "Historical norm",
	"RESET": "Reset",
	"SAVE_CHANGES": "Save changes",
	"PHONE": "Phone",
	"REQUEST_ACCESS": "Request access",
	"ADD_ORGANIZATION": "Add organization",
	"AGGREGATION": "Aggregation",
	"WEIGHTING": "Weighting",
	"ORGANIZATION_NAME": "Organization name",
	"ORGANIZATION_ADDRESS": "Organization address",
	"CITY": "City",
	"ZIP_CODE": "ZIP code",
	"ADMINISTRATORS": "Administrators",
	"NO_ADMINS": "There is no administrators in this organization.",
	"SEND": "Send",
	"RESET_PASSWORD": "Reset password",
	"RESETING": "Reseting",
	"PASSWORDS_NOT_MATCHING": "Passwords do not match.",
	"CHANGE_PASSWORD": "Change password",
	"OLD_PASSWORD": "Old password",
	"PROCESSING": "Processing...",
	"NO_STATIONS": "No stations were found",
	"SEARCH_STATIONS_PLACEHOLDER": "Search stations by 'siteName' or 'siteCode'",
	"ADD_VIRTUAL_STATION": "Add virtual station",
	"VIRTUAL_STATION": "Virtual station",
	"EDIT_ORGANIZATION": "Edit organization",
	"DISCHARGE_STATIONS": "Discharge stations",
	"METEOSTATIONS": "Meteostations",
	"HISTORICAL_DATA": "Historical data",
	"STEP_2_HISTORICAL_DATA": "Step 2: Historical Data",
	"ADD_METEOSTATION": "Add meteostation",
	"SHOW_TIME_SERIES": "Show time series",
	"EDIT_METEOSTATION": "Edit meteostation",
	"HYDROLOGICAL_METEOSTATIONS": "Hydrological Meteostations",
	"HISTORICAL_PRECIPITATION_DATA": "Historical Precipitation Data",
	"HISTORICAL_TEMPERATURE_DATA": "Historical Temperature Data",
	"PRECIPITATION": "Precipitation",
	"TEMPERATURE": "Temperature",
	"NAME_IS_ALREADY_USED": "Name is already used.",
	"STEP": "Step {stepNumber}:",
	"FORECAST_MODEL_LIST": "Forecast model list",
	"TYPE_NEW_FORECAST_MODEL_NAME": "Type in a name of a new model",
	"LEAVE_EMPTY_NO_FORECAST": "Leave empty if no foracst is required",
	"FORECAST_SETTINGS": "Forecast settings",
	"FORECAST_PARAMETERS": "Forecast parameters",
	"FREQUENCY": "Frequency",
	"METHOD": "Method",
	"METHOD_PARAMETERS": "Method parameters",
	"MODEL_PARAMETERS": "Model parameters",
	"DATASETS_USED": "Datasets used",
	"TRAIN_AND_ASSESS_MODEL": "Train & Assess model",
	"CURRENT_FORECASTING_PERIOD": "Current forecasting period",
	"FORECAST_NAME": "Forecast name",
	"FORECAST_ISSUE_DATES": "Forecast Issue Dates",
	"5_DAY": "5-day",
	"DECADAL": "Decadal",
	"MONTHLY": "Monthly",
	"SEASONAL": "Seasonal",
	"1ST_DAY_OF_FORECASTED_PERIOD": "The 1st day of a forecasted period",
	"ONE_DAY_BEFORE_FORECASTED_PERIOD": "One day before a forecasted period",
	"TWO_DAYS_BEFORE_FORECASTED_PERIOD": "Two days before a forecasted period",
	"THREE_DAYS_BEFORE_FORECASTED_PERIOD": "Three days before a forecasted period",
	"RELATIVE": "Relative",
	"START_DATE": "Start date",
	"END_DATE": "End date",
	"ISSUE_DATE": "Issue date",
	"SEASONAL_FREQUENCY_SETTINGS": "Seasonal frequency settings",
	"VALUES": "Values",
	"EVALUATION_STATISTICS": "Evaluation statistics",
	"DISCHARGE_CHARACTERISTICS": "Discharge characteristics",
	"FORECAST_VALUE": "Forecast value",
	"PREVIOUS_VALUE": "Previous value",
	"NUMBER_OF_TRAINING_DATA": "Number of training data",
	"ACCEPT": "Accept",
	"ACCESS": "Access",
	"HYDROLOGICAL_STATIONS_WITH_FORECASTING": "Hydrological stations with forecasting",
	"PERCENTAGE": "Percentage",
	"RELATIVE_ERROR": "Relative error",
	"STANDARD_DEVIATION": "Standard deviation",
	"NORM": "Norm",
	"ICE_PHENOMENA_11": "Salo",
	"ICE_PHENOMENA_12": "Snežura",
	"ICE_PHENOMENA_13": "Zaberegi",
	"ICE_PHENOMENA_14": "Pripaj",
	"ICE_PHENOMENA_15": "Zaberegi navisšie",
	"ICE_PHENOMENA_16": "Ledohod",
	"ICE_PHENOMENA_17": "Ledohod",
	"ICE_PHENOMENA_18": "Ledohod poverh ledjanogo pokrova",
	"ICE_PHENOMENA_19": "Šugohod",
	"ICE_PHENOMENA_20": "Vnutrivodnyj led",
	"ICE_PHENOMENA_21": "Pjatry",
	"ICE_PHENOMENA_22": "Osevšij led",
	"ICE_PHENOMENA_23": "Navaly lʹda na beregah",
	"ICE_PHENOMENA_24": "Ledjanaja peremyčka v stvore posta",
	"ICE_PHENOMENA_25": "Ledjanaja peremyčka vyše posta",
	"ICE_PHENOMENA_26": "Ledjanaja peremyčka niže posta",
	"ICE_PHENOMENA_30": "Zator lʹda vyše posta",
	"ICE_PHENOMENA_31": "Zator lʹda niže posta",
	"ICE_PHENOMENA_32": "Zator lʹda iskusstvenno razrušaetsja",
	"ICE_PHENOMENA_34": "Zažor lʹda vyše posta",
	"ICE_PHENOMENA_35": "Zažor lʹda niže posta",
	"ICE_PHENOMENA_36": "Zažor lʹda iskusstvenno razrušaetsja",
	"ICE_PHENOMENA_37": "Voda na lʹdu",
	"ICE_PHENOMENA_38": "Voda tečet poverh lʹda",
	"ICE_PHENOMENA_39": "Zakraina",
	"ICE_PHENOMENA_40": "Led potemnel",
	"ICE_PHENOMENA_41": "Snežnica",
	"ICE_PHENOMENA_42": "Led podnjalo",
	"ICE_PHENOMENA_43": "Podvižka lʹda",
	"ICE_PHENOMENA_44": "Razvodʹja",
	"ICE_PHENOMENA_45": "Led taet na mesto",
	"ICE_PHENOMENA_46": "Zaberegi ostatočnye",
	"ICE_PHENOMENA_47": "Naslud",
	"ICE_PHENOMENA_48": "Bityj led",
	"ICE_PHENOMENA_49": "Blinčatyj led",
	"ICE_PHENOMENA_50": "Ledjanye polja",
	"ICE_PHENOMENA_51": "Ledjanaja kaša",
	"ICE_PHENOMENA_52": "Stamuha",
	"ICE_PHENOMENA_53": "Led otnosit ot berega",
	"ICE_PHENOMENA_54": "Led prižimaet k beregu",
	"ICE_PHENOMENA_63": "Ledostav nepolnyj",
	"ICE_PHENOMENA_64": "Ledjanoj pokrov s polynʹjami",
	"ICE_PHENOMENA_65": "Ledostav, rovnyj ledjanoj pokrov",
	"ICE_PHENOMENA_66": "Ledostav, ledjanoj pokrov s torosami",
	"ICE_PHENOMENA_67": "Ledjanoj pokrov s grjadami torosov",
	"ICE_PHENOMENA_68": "Šugovaja dorožka",
	"ICE_PHENOMENA_69": "Podo lʹdom šuga",
	"ICE_PHENOMENA_70": "Treŝiny v ledjanom pokrove",
	"ICE_PHENOMENA_71": "Naledʹ",
	"ICE_PHENOMENA_72": "Led navisšij",
	"ICE_PHENOMENA_73": "Led jarusnyj",
	"ICE_PHENOMENA_74": "Led na dne",
	"ICE_PHENOMENA_75": "Reka promerzla",
	"ICE_PHENOMENA_76": "Led iskusstvenno razrušen",
	"ICE_PHENOMENA_77": "Nalednaja voda",
	"KN15_ERRORS_TOO_SHORT_TOKEN": "Telegram parts must have 5 characters.",
	"KN15_ERRORS_NO_STATION_CODE": "No station code is present.",
	"KN15_ERRORS_INVALID_DAY_IN_MONTH": "Day in month must be a number.",
	"KN15_ERRORS_UNSUPPORTED_HOUR_CODE": "Only 08 hour is supported.",
	"KN15_ERRORS_OUT_OF_RANGE_DAY_IN_MONTH": "Day in month is out of range.",
	"KN15_ERRORS_INVALID_SECTION_CODE": "Section code must be a number.",
	"KN15_ERRORS_UNSUPPORTED_SECTION_CODE": "Only section code 1 and 2 are supported",
	"KN15_ERRORS_UNSUPPORTED_SECTION": "Only sections 933, 966 and 988 are supported. Please check that discharge indetifier number is not \"1\".",
	"KN15_ERRORS_INVALID_GROUP_ONE": "Group 1HHHH is not present.",
	"KN15_ERRORS_INVALID_WATER_LEVEL": "Invalid water level.",
	"KN15_ERRORS_INVALID_GROUP_TWO": "Group 2HHHK is not present.",
	"KN15_ERRORS_INVALID_TREND": "Invalid water level trend.",
	"KN15_ERRORS_INVALID_GROUP_THREE": "Group 3HHHH is not present.",
	"KN15_ERRORS_INVALID_TEMPERATURE": "Invalid water and/or air temperature.",
	"KN15_ERRORS_INVALID_ICE_PHENOMENA": "Invalid ice phenomena code and/or intensity.",
	"KN15_ERRORS_INVALID_MONTH": "Invalid month number.",
	"KN15_ERRORS_INVALID_GROUP_TWO_DISCHARGE": "Group 2kQQQ is not present.",
	"KN15_ERRORS_INVALID_DISCHARGE_VALUE": "Invalid discharge value.",
	"KN15_ERRORS_INVALID_FREE_RIVER_AREA_VALUE": "Invalid cross-section area value.",
	"KN15_ERRORS_INVALID_MAXIMUM_DEPTH_VALUE": "Invalid maximum depth value.",
	"KN15_ERRORS_INVALID_GROUP_FIVE": "Group 5YYGG is not present.",
	"KN15_ERRORS_OUT_OF_RANGE_HOUR": "Hour is out of range.",
	"PASTE_MULTIPLE_KN_15_TELEGRAMS": "Paste multiple KN-15 telegrams",
	"ADD_SINGLE_TELEGRAM": "Add single telegram",
	"AUTOMATICALLY_PROCESSED_TELEGRAMS": "Automatically processed telegrams",
	"COMPLETED_TELEGRAMS": "Completed telegrams",
	"TELEGRAMS_REQUIRING_ACTION": "Telegrams requiring action",
	"DATA_OVERVIEW": "Data overview",
	"DATA_PROCESSING": "Data processing",
	"PRECIPITATION_NORM": "Precipitation norm",
	"TEMPERATURE_NORM": "Temperature norm",
	"NO_METEOSTATION_FOR_CODE": "No meteostation",
	"NO_METEOSTATION_FOR_CODE_EXTENDED": "No meteostation corresponding with discharge station with code {stationCode}. If you don't create a meteostation with the same station code, meteo data will be ignored upon submission.",
	"CREATE_METEOSTATION": "Create meteostation",
	"STATION_PAIR_NOTIFICATION": "Existing {stationType} Station ({stationCode})",
	"STATION_PAIR_NOTIFICATION_EXTENDED": "{stationType} station with the same station code ({stationCode}) already exists. Subsequent telegram data with this station code will automatically be submitted for each station separately depending on its type.",
	"MM_DAY": "mm/day",
	"NO_DAILY_DATA": "No daily data",
	"NO_DISCHARGE_DATA": "No discharge data",
	"NO_DECADAL_DATA": "No decadal data",
	"ERROR": "Error",
	"NEW_TELEGRAM_DATA_ENTRY": "New entry",
	"OLD_TELEGRAM_DATA_ENTRY": "Old entry",
	"OVERRIDE_OLD_ENTRY": "Override old entry",
	"MANUAL_INPUT": "Manual input",
	"DISCHARGE_STATIONS_WITH_MISSING_TELEGRAMS": "Discharge stations with missing telegrams",
	"METEO_STATIONS_WITH_MISSING_TELEGRAMS": "Meteo stations with missing telegrams",
	"METEO_DATA": "Meteo data",
	"DISCHARGE_CURVE_ADJUSTMENT": "Current curve adjustment",
	"NO_CURVE_FOR_METEO": "Discharge curve is not available for a station with only meteo data.",
	"CATCHMENT_AREA_FILE_UPLOAD": "Catchment area file upload",
	"STEP_4_SNOW_DATA": "Step 4: Snow Data",
	"SHOW_SNOW_DATA": "Show snow data",
	"SNOW_DATA": "Snow data",
	"LOAD_SNOW_DATA": "Load snow data",
	"FORECAST_TYPE": "Forecast type",
	"FORECAST_TYPE_DETAILS": "Forecast type details",
	"SUBMIT_MODEL": "Submit model",
	"SHOW_FORECAST_MODELS": "Show forecast models",
	"CURRENT_CURVE_ADJUSTMENT": "Current curve adjustment",
	"CURVE_MANAGEMENT": "Curve management",
	"ALL_CURVES": "All curves",
	"COMPLETION": "Completion",
	"STARTED": "Started",
	"LAST_MODIFIED": "Last modified",
	"PDF_REPORT": "PDF report",
	"TRAINING_INFO": "Training info",
	"FEATURE_TIMELAG": "Feature timelag",
	"EDIT_FORECAST_MODEL": "Edit forecast model",
	"FORECAST_MODEL_SETUP": "Forecast model setup",
	"FORECAST_MODEL_SETUP_EXTENDED": "Do you want to set up forecast models for this station now?",
	"NON_REVERTIBLE_ACTION": "This is non-revertible action. Do you wish to proceed?",
	"AUTOMATICALLY_ACCEPT_FORECAST_VALUES": "Automatically accept forecast values",
	"FORECAST_BULLETIN": "Forecast bulletin",
	"CANCEL_MODEL_TRAINING": "Cancel model training",
	"CANCEL_MODEL_TRAINING_CONFIRMATION": "Are you sure you want to cancel model training?",
	"YES": "Yes",
	"NO": "No",
	"VERIFY_PAYMENT": "Verify payment",
	"ENABLED_UNTIL_DATE": "Enabled until {date}",
	"DISABLED": "Disabled",
	"ACCESS_REQUESTED": "Access requested",
	"ACTIONS": "Actions",
	"ACTIVATE_OR_RENEW_SUBSCRIPTIONS": "Activate or renew subscription",
	"PAYMENT_VERIFICATION_CONFIRMATION": "Are you sure you want to verify payment for {organization}?",
	"INVITATIONS": "Invitations",
	"REGISTER": "Register",
	"ISSUE_DATE_OFFSET": "Issue date offset",
	"TARGET_PERIOD_START": "Target period start",
	"TARGET_PERIOD_END": "Target period end",
	"REFRESH_TRAINING_INFO": "Refresh training info",
	"TIMEZONE": "Timezone",
	"SELECT_TIMEZONE": "Select timezone",
	"TEMPLATES": "Templates",
	"TIMEZONE_NOTE": "If your organization operates within multiple timezones leave this field empty.",
	"NO_MATCH": "No match",
	"GENERATE_PREDICTION_MANUALLY": "Generate prediction manually",
	"PREDICTION_DATE": "Prediction date",
	"NO_CONTENT": "No content",
	"BULK_DATA_DOWNLOAD": "Bulk data download",
	"GENERATE_BULK_DATA": "Generate bulk data",
	"REPORTING_TEMPLATES": "Reporting templates",
	"DAILY_BULLETIN": "Daily bulletin",
	"DECADAL_BULLETIN": "Decadal bulletin",
	"TEMPLATE_TAGS": "Template tags",
	"DEFAULT_TEMPLATE": "Default template",
	"CURRENT_TEMPLATE": "Current template",
	"BULK_DATA": "Bulk data",
	"PREPARE_BULK_DATA": "Prepare bulk data",
	"BULK_DATA_DATE": "Bulk data date",
	"DECADAL_OPERATIONAL_BULLETIN": "Decadal operational bulletin",
	"NO_FORECAST_TYPES": "Organization has no forecast types defined.",
	"YEAR_WILL_BE_IGNORED": "Year will be ignored",
	"FORECAST_TYPE_CHANGE_WARNING": "Changing forecast type settings requires a new forecast model training for forecast models which are based on a changed forecast type.",
	"FAILED_TO_LOAD_USER": "Failed to load user",
	"FAILED_TO_LOAD_ORGANIZATIONS": "Failed to load organizations",
	"SAVE_FAILED": "Save failed",
	"NO_STATIONS_WITH_FORECAST": "No stations with forecast",
	"NO_FORECAST_MODELS": "No forecast models",
	"MANUAL_DISCHARGE_INPUT": "Manual discharge input (ice phenomena included)",
	"MANUAL_WATER_LEVEL_INPUT": "Manual water level input (water level trend differs)",
	"MIN_TEMPLATE_TAG_NOTE": "There should be at minimum one header tag and one one body tag.",
	"NO_DISCHARGE_CURVE_FOR_SITE_WITH_CODE": "No discharge curve for site with code {siteCode}",
	"LANGUAGE": "Language",
	"ENGLISH": "English",
	"RUSSIAN": "Russian",
	"LANGUAGE_NOTE": "Used for emails.",
	"WE_WILL_CONTACT_YOU_ASAP": "We will contact you as soon as we can!",
	"WE_ARE_SORRY": "We are sorry",
	"HELP_MESSAGE_ERROR": "Due to an error on our side, we were unable to send your message. Please try again.",
	"THANK_YOU": "Thank you",
	"CONTACT_US_FOR_HELP": "Contact us for help",
	"YOUR_NAME": "Your name",
	"YOUR_EMAIL": "Your email",
	"MESSAGE": "Message",
	"SENDING": "Sending",
	"APP_TITLE": "Modern Operational Hydrometeorology for Mountain Rivers in Central Asia",
	"FILE_UPLOADED": "File uploaded",
	"SNOW_DATA_FILE_NOTE": "Please rename the file extension to '.json' before uploading a file.",
	"HISTORICAL_METEOSTATION_DATA": "Historical Temperature and Precipitation Data",
	"PENTAD_FORECAST_DETAILS": "(Pentad) Recurring pentad forecast. Issue date: 1st day of Pentade +- {lag}",
	"DECADAL_FORECAST_DETAILS": "(Decadal) Recurring decadal forecast. Issue date: 1st day of Decade +- {lag}",
	"MONTHLY_FORECAST_DETAILS": "(Monthly) Recurring monthly forecast. Issue date: 1st day of Month +- {lag}",
	"SEARCH_STATION_CODE": "Search station by station code",
	"BACK_TO_STATION_LIST": "Back to station list",
	"FIRST_PAGE": "First page",
	"PREVIOUS_PAGE": "Previous page",
	"NEXT_PAGE": "Next page",
	"LAST_PAGE": "Last page",
	"PROCESS": "Process",
	"SNOW_COVER_DEVELOPMENT": "Snow cover development",
	"SNOW_COVER_MAP": "Snow cover map",
	"MEAN_CATCHMENT_NDSI": "Mean Catchment NDSI",
	"NDSI_NORM": "NDSI Norm",
	"MONTHLY_VALUES": "Monthly Values",
	"CATCHMENT_AREA_SETUP": "Catchment area setup",
	"DELETE_CATCHMENT_CONFIRM": "Are you sure you want to delete the catchment area file? Please consider exporting the data if you wish to proceed because the current data won't be accessible anymore.",
	"NORMALIZED_DIFF_SNOW_INDEX_MAP": "Normalized-Difference Snow Index (NDSI) Map",
	"RED": "Red",
	"DARK_BLUE": "Dark blue",
	"LOW_NDSI": "Low NDSI",
	"HIGH_NDSI": "High NDSI",
	"NO_DATA": "No data",
	"CURRENT": "Current",
	"SELECT_FORECASTING_PERIOD": "Select forecasting period",
	"YEAR_TYPE": "Year type",
	"HYDRO_YEAR": "Hydrological year",
	"CALENDAR_YEAR": "Calendar year"
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/locale-en.json
 ** module id = 567
 ** module chunks = 0
 **/